<template>
  <div class="InformationMassagePush">
    <div class="editor-container">
      <div ref="editorElem" style="height: 550px;"></div>
    </div>
    <div style="display:flex;justify-content:center">
      <el-button :size="size" type="primary" plain @click.native="submitForm" :loading="sureLoading">保存</el-button>
    </div>
  </div>
</template>
<script>
import wangEditor from 'wangeditor'
export default {
  name: "InformationMassagePush",
  data() {
    return {
      fileList: [],
      groupId: "", //机构id
      size: "medium", //按钮的尺寸
      sureLoading: false, //按钮加载
      remarkLength: "", //富文本字符长度
      editor:null,
      content: "",
      dataForm: {
        remark: ""
      }
    };
  },
  methods: {
   
    //富文本编辑框回显数据
    setUEContent(val) {
      this.content = val;
      this.editor.txt.html(val)
    },

    /* 
      点击提交数据
    */
    submitForm() {
      this.upResource();
    },

    /* 
      上传的资源
    */
    upResource() {
      let remark =  this.content
            .replace(/<[^<>]+>/g, "")
            .replace(/&nbsp;/gi, "");
      let params = {
        message: this.content,
        remark: remark
      };
      this.$postJson("omc/queryMachine/saveMessage", params).then(res => {
        if (res.code == 200) {
          this.$message({ message: res.message, type: "success" });
        } else {
          this.$message({ message: res.message, type: "error" });
        }
      });
    },

    //数据回显
    backDetail(id){
        this.$postJson("omc/queryMachine/getMessage").then(res =>{
          this.setUEContent(res.result[0].message); //加载完成调取函数回显富文本框的数据
        })
    }
  },
  created() {
    this.groupId = sessionStorage.getItem("groupId");
  },
  destroyed() {
    // 销毁编辑器
    this.editor.destroy();
 },
  mounted() {
    this.editor = new wangEditor(this.$refs.editorElem);
    // 配置编辑器
    this.editor.config.uploadImgShowBase64 = false; // 显示Base64编码的图片
    this.editor.config.uploadImgMaxLength = 3 * 1024 * 1024; // 限制上传图片的大小为5MB
    this.editor.config.emotions = null;
    this.editor.config.onchange = html => {
      this.content = html;
    };
    // 创建编辑器
    this.editor.create();
    this.backDetail(this.$route.params.id)
    
  },
};
</script>
<style lang="scss" scoped>
.InformationMassagePush {
  width: 100%;
  height: 100%;
  .editor-container {
    width: 100%;
    height: 600px;
  }
}
::v-deep .w-e-text-container{
  height: 95% !important;
}
</style>